module.exports = __webpack_public_path__ + "54f0337b83806fcc0a2b4af359d92683.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/dreidel-s.png
// module id = 2016
// module chunks = 0